module.exports = __webpack_public_path__ + "assets/img/heroPrivate.a0012d10.jpg";